import { Typography } from '@remarkable/ark-web';
import { useState } from 'react';
import { useEnterpriseOrgSettings } from 'src/api/queries/enterpriseAdmin';
import { TestId } from 'src/testids';
import { enterpriseHelpers } from 'src/utils/enterpriseHelpers';
import { Modal } from '.';
import { Button } from './Button';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import { StartEnterpriseDomainForwardingNotificationModal } from './StartEnterpriseDomainForwardingNotificationModal';

export function StartEnterpriseDomainForwardingNotification() {
  const orgSettings = useEnterpriseOrgSettings();
  const primaryDomain = enterpriseHelpers.getPrimaryDomain(orgSettings.data);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div
      data-cy={TestId.NotificationEnterpriseStartDomainForwarding}
      className="flex flex-col gap-24 border border-neutral-light-8 p-24"
    >
      <div className="flex flex-col items-center gap-24 lm:flex-row">
        <div>
          <Typography variant="heading-subtle-xl" as="h3">
            Complete migration and activate domain forwarding
          </Typography>
          <Typography variant="body-md">
            When you decide that all users are ready, you can activate domain
            forwarding, which forces all users from the domain to authenticate
            via SSO. At this point the migration period is completed and login
            via legacy credentials is no longer supported.
          </Typography>
        </div>

        <Modal.Root
          open={isOpen}
          onOpenChange={(newState) => setIsOpen(newState)}
        >
          <Modal.Trigger asChild>
            <Button
              disabled={!primaryDomain}
              variant="primary"
              className="w-full whitespace-nowrap ls:w-fit"
              analytics={{
                action: 'open start enterprise domain forwarding modal',
                location: ComponentLocations.ENTERPRISE.MEMBERS_PAGE,
                text: 'Complete migration',
              }}
            >
              Complete migration
            </Button>
          </Modal.Trigger>

          <StartEnterpriseDomainForwardingNotificationModal
            setIsOpen={setIsOpen}
            componentLocation={ComponentLocations.ENTERPRISE.MEMBERS_PAGE}
            primaryDomain={primaryDomain}
          />
        </Modal.Root>
      </div>
    </div>
  );
}
